module.exports = __webpack_public_path__ + "static/texgyreheros-regular-webfont-4b507b0104c18eddfd15cbbffeab57a4.woff";